/**
 * Compile-time exhaustiveness check for discriminated unions.
 *
 * Use as the default branch of a `switch` over a discriminated union: TypeScript
 * narrows the discriminant to `never` when every case is handled, so passing the
 * value to `assertNever` compiles. Adding a new variant later breaks the call
 * site at compile time, forcing the switch to be updated.
 *
 * At runtime, throws to surface the bug in case the type system was bypassed
 * (e.g. unsafe cast, malformed payload).
 */
export function assertNever(value) {
    throw new Error(`Unexpected value: ${JSON.stringify(value)}`);
}
//# sourceMappingURL=typeGuards.js.map